"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column'
    },
    top: {
      color: theme.palette.secondary.navIcon
    },
    divider: {
      '&:before': {
        content: '" "'
      },
      '&:after': {
        content: '" "'
      }
    }
  };
};

exports.default = _default;